import { BaseModel } from "sjs-base-model";
import Moment from "moment";
import UserModel from "../user/UserModel";
import { urlPdfResponsive } from "../../../api/urls";
import {
  RESPONSIVA_STATUS_PENDING,
  RESPONSIVA_STATUS_PENDING_AFTER_REJECTED,
  RESPONSIVA_STATUS_PENDING_SUPER_RESPONSIBLE,
  RESPONSIVA_STATUS_PENDING_SUPER_RESPONSIBLE_AFTER_REJECTED,
  RESPONSIVA_STATUS_REJECTED,
  RESPONSIVA_STATUS_REVOKED,
} from "../../../constants/responsivas";

const ID = "id";
const MODULE_CLIENT_ID = "moduleClientId";
const MODULE_NAME = "moduleName";
const STATUS = "status"; //"NONE", "PENDING", "VALIDATED", "REJECTED", "REVOKED", "PENDING_AFTER_REJECTED", "PENDING_SUPER_RESPONSIBLE"
const UPDATED_DATE = "updateDate"; //fecha de cambio de estado
const REQUESTING_USER = "requestingUser"; //solicitante
const RESPONSIBLE_USER = "appManager"; //responsable que firma/valida la solicitud
const SUPER_RESPONSIBLE_USER = "superManagerUser"; //super responsable (encargado de validar a los admin)
const YEAR = "year";
const IS_ADMIN = "isAdmin";
const SUPER_MANAGER_SIGN_DATE = "superManagerSignDate"; //fecha de la firma del super responsable
const REQUESTING_USER_SIGN_DATE = "requestingUserSignDate"; //fecha de la firma del solicitante
const RESPONSIBLE_SIGN_DATE = "appManagerSignDate"; //fecha de la firma del responsable
const DATA = "data"; //datos de acceso de la responsiva
const ACTIVE = "active";

export const RESPONSIVE_PROPERTIES = {
  ID: ID,
  STATUS: STATUS,
  REQUESTING_USER: REQUESTING_USER,
  RESPONSIBLE_USER: RESPONSIBLE_USER,
  SUPER_RESPONSIBLE_USER: SUPER_RESPONSIBLE_USER,

  MODULE_CLIENT_ID: MODULE_CLIENT_ID,
  YEAR: YEAR,
  IS_ADMIN: IS_ADMIN,
  UPDATED_DATE: UPDATED_DATE,
  SUPER_MANAGER_SIGN_DATE: SUPER_MANAGER_SIGN_DATE,
  REQUESTING_USER_SIGN_DATE: REQUESTING_USER_SIGN_DATE,
  RESPONSIBLE_SIGN_DATE: RESPONSIBLE_SIGN_DATE,
  DATA: DATA,
  ACTIVE: ACTIVE,
  MODULE_NAME: MODULE_NAME,
};

export default class ResponsiveModel extends BaseModel {
  [ID] = null;
  [STATUS] = null;
  [REQUESTING_USER] = UserModel;
  [MODULE_CLIENT_ID] = null;
  [MODULE_NAME] = null;
  [RESPONSIBLE_USER] = UserModel;
  [SUPER_RESPONSIBLE_USER] = UserModel;
  [YEAR] = null;
  [IS_ADMIN] = false;
  [UPDATED_DATE] = null;
  [SUPER_MANAGER_SIGN_DATE] = null;
  [REQUESTING_USER_SIGN_DATE] = null;
  [RESPONSIBLE_SIGN_DATE] = null;
  [DATA] = null;
  [MODULE_NAME] = null;
  [ACTIVE] = false;

  constructor(data) {
    super();
    this.update(data);
  }

  getId = () => this[ID];
  isPending = () =>
    this[STATUS] === RESPONSIVA_STATUS_PENDING ||
    this[STATUS] === RESPONSIVA_STATUS_PENDING_AFTER_REJECTED ||
    this[STATUS] === RESPONSIVA_STATUS_PENDING_SUPER_RESPONSIBLE ||
    this[STATUS] === RESPONSIVA_STATUS_PENDING_SUPER_RESPONSIBLE_AFTER_REJECTED;
  isDisable = () =>
    this[STATUS] === RESPONSIVA_STATUS_REJECTED || this[STATUS] === RESPONSIVA_STATUS_REVOKED || !this[ACTIVE];
  isInactive = (year) => this[YEAR] != year || !this[ACTIVE];
  getStatus = () => this[STATUS];
  getYear = () => this[YEAR];
  getIsAdmin = () => this[IS_ADMIN];
  getModuleClientId = () => this[MODULE_CLIENT_ID];
  getModuleName = () => this[MODULE_NAME];
  getRequestingUser = () => this[REQUESTING_USER];
  getSuperResponsibleSignDate = () => this[SUPER_MANAGER_SIGN_DATE];
  getResponsibleUser = () => this[RESPONSIBLE_USER];
  getSuperResponsibleUser = () => this[SUPER_RESPONSIBLE_USER];

  /*   getNotEditableByUser = (user) =>
    this.getStatus() === RESPONSIVA_STATUS_REJECTED ||
    ((this.getStatus() === RESPONSIVA_STATUS_PENDING_SUPER_RESPONSIBLE ||
      this.getStatus() === RESPONSIVA_STATUS_PENDING_SUPER_RESPONSIBLE_AFTER_REJECTED) &&
      this.getSuperResponsibleUser() &&
      this.getSuperResponsibleUser().userLogin !== user.getId()); */

  getRequestingUserSignDate = () => this[REQUESTING_USER_SIGN_DATE];
  getRequestingUserLogin = () => this[REQUESTING_USER].getLogin();
  getData = () => (this[DATA] ? JSON.parse(this[DATA]) : null);
  getUrl = () => urlPdfResponsive(this[ID]);

  setStatus = (v) => (this[STATUS] = v);
  getModelProperty = (p) => this[p];
  setModelProperty = (property, value) => (this[property] = value);

  getSaveFields = () => {
    let resp = {
      [STATUS]: this[STATUS],
      // [RESPONSIBLE_USER]: this[RESPONSIBLE_USER].getId(),
    };
    return resp;
  };
}
